export default __webpack_public_path__ + "static/Icon-Cirurgica-4eb5bc6651d92f09a39b6419e8ac5c75.svg";